__turbopack_context__.v({
  "className": "fontroboto_6a36ade4-module__xJDkmW__className",
});
